import React from "react";
import {BodyContent} from "../BodyContent";
import {Switch, useHistory} from "react-router-dom";
import {Redirect, Route} from "react-router";
import {DefaultRoutes} from "../../../../../routes";
import {Navigation} from "../Navigation";
import {QuestionsPage} from "../../../../../pages/QuestionsPage";
import {TopicsPage} from "../../../../../pages/TopicsPage";
import {SkillsPage} from "../../../../../pages/SkillsPage";
import {CircularProgress, Grid, Link, Typography} from "@mui/material";

interface BodyProps {
  open: boolean;
  onDrawerClose: () => void;
  loading: boolean;
}

export default function Body({ open, onDrawerClose, loading }: BodyProps) {
  const { push } = useHistory();

  const onMainPageClick = () => push(`/`);

  return (
    <>
      <Navigation open={open} onDrawerClose={onDrawerClose} />
      <BodyContent>
        {loading
          ? (
            <Grid container justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          )
          : (
            <Switch>
              <Redirect from="/" exact to={DefaultRoutes.questions} />
              <Route path={`/${DefaultRoutes.questions}`} component={QuestionsPage} />
              <Route path={`/${DefaultRoutes.topics}`} component={TopicsPage} />
              <Route path={`/${DefaultRoutes.skills}`} component={SkillsPage} />
              <Route path={`/page404`} render={() => {
                return (
                  <div>
                    <Typography variant={"h5"}>Такой страницы не существует</Typography>
                    <Link sx={() => ({ cursor: "pointer" })} underline={"hover"} onClick={onMainPageClick}>На главную</Link>
                  </div>
                )
              }} />
            </Switch>
          )
        }
      </BodyContent>
    </>
  );
}
